import { styled, Button, Box } from '@mui/material';

interface SwitchButtonProps {
  selected: boolean;
}

export const ComponentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  my: 3,
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.1),
}));

export const SwitchContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-evenly',
}));

export const PaymentIntervalButton = styled(Button)<SwitchButtonProps>(
  ({ theme, selected }) => ({
    fontSize: 16,
    textTransform: 'uppercase',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    transition: 'background-color 0.3s',
    '&:hover': {
      color: selected ? theme.palette.grey[900] : theme.palette.grey[50],
      backgroundColor: selected ? theme.palette.grey[50] : 'transparent',
    },
    '&:active, &:focus': {
      color: selected ? theme.palette.grey[900] : theme.palette.grey[50],
      backgroundColor: selected ? theme.palette.grey[50] : 'transparent',
    },
    color: selected ? theme.palette.grey[900] : theme.palette.grey[100],
    backgroundColor: selected ? theme.palette.grey[50] : 'transparent',
  })
);
